import { LoginService } from './../commons/servicos/login.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SessionAnuglarService } from './session-anuglar.service';
import { UserUtil } from './user-util';
import { AuthenticationService } from '../commons/servicos/authentication.service';

@Injectable()
export class CanActivateAuthGuard implements CanActivate {

  estalogado = true;
  verifyTokenExterno: string;

  constructor(private router: Router,
      private loginService: LoginService,
      private authenticationService: AuthenticationService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (SessionAnuglarService.isLoggedIn()) {
        // logged in so return true
        return true;
    }

    this.verifyTokenExterno = route.queryParams ? route.queryParams['t'] : null;
    const usuario = route.queryParams ? route.queryParams['u'] : null;
    if (this.verifyTokenExterno) {
      this.loginService.validarTokenMobile(this.verifyTokenExterno, usuario).subscribe(resposta => {
        if (resposta && resposta['tipo'] && resposta['tipo'] === 'SUCESSO' &&
                resposta['data'] && resposta['data'].token) {
            UserUtil.usuarioLogado = resposta['data'];
            localStorage.setItem('currentUser', JSON.stringify(UserUtil.usuarioLogado));
            UserUtil.onLoadParametros.subscribe(parametros => {
              UserUtil.parametrosList = parametros;
              localStorage.setItem('parametros', JSON.stringify(UserUtil.parametrosList));
              this.router.navigate([route.routeConfig.path], { skipLocationChange: true });
            });
            this.authenticationService.buscarParametros();
          return true;
        } else {
          const msg = resposta['mensagem'] ? resposta['mensagem'] : 'Não foi possível acessar a API de acesso.';
          this.router.navigate(['/erro', {mensagem: msg}], { skipLocationChange: true });
        }
      });
    }

    // not logged in so redirect to login page with the return url and return false
    this.router.navigate(['/login', {urlRefer: state.url}], { skipLocationChange: true });
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/can-active.authguard.ts